import { STRINGS } from 'config';
import * as primaryCareAndEtriageModals from './modal';
import * as outpatientModals from './especialistModals';

const { PRODUCT } = STRINGS;

export function getModals(product) {
  return product === PRODUCT.E_SPECIALIST ? outpatientModals : primaryCareAndEtriageModals;
}
